import { render, staticRenderFns } from "./ChatterFlexibleDashboardCard2.vue?vue&type=template&id=33007123&scoped=true"
import script from "./ChatterFlexibleDashboardCard2.vue?vue&type=script&lang=js"
export * from "./ChatterFlexibleDashboardCard2.vue?vue&type=script&lang=js"
import style0 from "./ChatterFlexibleDashboardCard2.vue?vue&type=style&index=0&id=33007123&prod&scoped=true&lang=css"
import style1 from "./ChatterFlexibleDashboardCard2.vue?vue&type=style&index=1&id=33007123&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33007123",
  null
  
)

export default component.exports